import { render, staticRenderFns } from "./faturalistesi.vue?vue&type=template&id=303c3820&"
import script from "./faturalistesi.vue?vue&type=script&lang=js&"
export * from "./faturalistesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports